import { FunctionComponent, useEffect } from 'react';
import { useMap } from 'react-leaflet';

// Zooms with the wheel only with Ctrl (⌘ on Mac) held, the wheel alone keeps
// scrolling the page. A trackpad pinch is a wheel with Ctrl held.
const MapModifierWheelZoom: FunctionComponent = () => {
  const map = useMap();

  useEffect(() => {
    const container = map.getContainer();

    // Captured, to stop the wheel before the leaflet handler on the container.
    // The leaflet handler prevents the page zoom of the browser on Ctrl.
    const onWheel = (event: WheelEvent) => {
      if (!event.ctrlKey && !event.metaKey) {
        event.stopPropagation();
      }
    };

    container.addEventListener('wheel', onWheel, true);
    map.scrollWheelZoom.enable();

    return () => {
      map.scrollWheelZoom.disable();
      container.removeEventListener('wheel', onWheel, true);
    };
  }, [map]);

  return null;
};

export default MapModifierWheelZoom;
